const getFilterTime = (t, s) => {
  return (t === 'a' || t === 'an' ? '1' : t) + s;
};

export default d => {
  let darr = d.split(' ');
  if (darr[1] === 'days' || darr[1] === 'day') {
    d = getFilterTime(darr[0], 'd');
  } else if (darr[1] === 'seconds' || darr[1] === 'second' || darr[1] === 'few') {
    d = getFilterTime(darr[0], 's');
  } else if (darr[1] === 'minutes' || darr[1] === 'minute') {
    d = getFilterTime(darr[0], 'm');
  } else if (darr[1] === 'hours' || darr[1] === 'hour') {
    d = getFilterTime(darr[0], 'h');
  } else if (darr[1] === 'months' || darr[1] === 'month') {
    d = getFilterTime(darr[0], 'M');
  } else if (darr[1] === 'years' || darr[1] === 'year') {
    d = getFilterTime(darr[0], 'y');
  }
  return d + ' ago';
};
